<template>
  <v-card>
    <v-layout row wrap>
      <v-flex xs12 md4 class="hidden-sm-and-down">
        <v-date-picker
          class="elevation-0"
          color="primary"
          v-model="fecha"
          locale="es-es"
          first-day-of-week="1"
        ></v-date-picker>
      </v-flex>
      <v-flex xs1 class="hidden-sm-and-down">
        <v-divider vertical></v-divider>
      </v-flex>
      <v-flex xs12 md6 class="pa-3">
        <h3 class="primary--text headline text-center text-md-left">Crear Nueva Promoción</h3>
        <h4 class="text-center text-md-left">
          Válida hasta el
          <span class="primary--text">{{
            $moment(fecha).format('dddd DD MMM YYYY')
          }}</span>
        </h4>
        <v-btn class="hidden-md-and-up" depressed flat block @click="openMobileDate"> seleccionar fecha termino</v-btn>
        <div style="position:relative;">
          <span class="discount" style="z-index:100;" v-if="descuento > 0 && descuento <= 100">
            <h2>-{{descuento}}%</h2>
          </span>
          <v-img :src="image" class="mt-2" aspect-ratio="2"></v-img>
          <v-btn
            class="elevation-5"
            icon
            color="red"
            dark
            style="position:absolute;bottom:5px;right:5px;"
            @click="pickFile"
          >
            <v-icon small>
              fas fa-camera
            </v-icon>
          </v-btn>
          <input
            type="file"
            ref="imagePicker"
            accept="*image/*"
            style="display:none;"
            @change="onFilePicked"
          />
        </div>
        <v-form ref="form">
          <v-autocomplete
            :items="services"
            item-text="fullName"
            return-object
            autofocus
            label="Servicio"
            placeholder="Nombre del servicio"
            v-model="servicio"
            :rules="[rules.requerido]"
          ></v-autocomplete>
          <v-card v-if="servicio" class="pa-2 mt-2 primary white--text">
            <h3 class="">{{ servicio.fullName }}</h3>
            <div class="text-right">
              <p class="mb-0">
                Valor $ {{ servicio.price.toLocaleString('es') }} | Con
                Descuento $ {{ calculatedPrice.toLocaleString('es') }}
              </p>
              <p class="mb-0">
                <small>
                  {{
                    servicio.taxFree
                      ? 'Servicio NO aplica impuesto'
                      : 'Servicio debe aplicar impuesto'
                  }}
                </small>
              </p>
            </div>
          </v-card>
          <v-text-field
            label="Título"
            v-model="titulo"
            :rules="[rules.requerido, rules.largo]"
            validate-on-blur
          ></v-text-field>
          <v-textarea
            rows="3"
            label="Descripción"
            v-model="descripcion"
            :rules="[rules.requerido, rules.largo]"
            validate-on-blur
          ></v-textarea>
          <v-text-field
            label="Descuento"
            suffix="%"
            v-model="descuento"
            :rules="[rules.isNaN, rules.requerido, rules.percent]"
            validate-on-blur
          ></v-text-field>
          <v-layout row wrap>
            <v-flex xs4>
              <v-btn block @click="close" flat>Cancelar</v-btn>
            </v-flex>
            <v-flex xs8 class="pl-3">
              <v-btn
                color="primary"
                text
                block
                :loading="loading"
                @click="createOffer"
                >Crear Promoción</v-btn
              >
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
      <v-flex xs1 class="hidden-sm-and-down"></v-flex>
    </v-layout>
    <v-dialog v-model="dateModal" max-width="280px">
      <v-card>
        <v-date-picker
          class="elevation-0"
          color="primary"
          v-model="fecha"
          locale="es-es"
          first-day-of-week="1"
        ></v-date-picker>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import { ApiUtils } from '@/utils/ApiUtils'
import { largo } from '@/utils/Validators'

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    services: {
      type: Array,
      default: () => []
    }
  },
  components: {
    AddService: () => import('@/components/providers/services/AddService')
  },
  data() {
    return {
      fecha: '',
      servicio: null,
      descuento: 0,
      titulo: '',
      descripcion: '',
      image: 'http://placehold.it/400x200',
      imageFile: null,
      loading: false,
      dateModal: false,
      rules: {
        requerido: val => !!val || 'Campo obligatorio',
        largo: val => largo(val, 5) || 'Debe tener la menos 5 caracteres',
        isNaN: val => !isNaN(val) || 'Cifra debe ser numérica',
        percent: val => {
          if (+val > 0 && +val <= 100) return true
          else return 'Debe ser un valor entre 1 y 100'
        }
      }
    }
  },
  async mounted() {
    this.clean()
  },
  watch: {
    fecha: function(val) {
      if (val) this.dateModal = false
    }
  },
  computed: {
    calculatedPrice() {
      if (this.servicio)
        return (
          this.servicio.price - this.servicio.price * (this.descuento / 100)
        )
      return 0
    }
  },
  methods: {
    pickFile() {
      this.$refs.imagePicker.click()
    },
    onFilePicked(ev) {
      const files = ev.target.files
      const fr = new FileReader()
      fr.readAsDataURL(files[0])
      fr.addEventListener('load', () => {
        this.image = fr.result
        this.imageFile = files[0]
      })
    },
    validateOffer(offer) {
      if (!this.$refs.form.validate()) {
        this.$store.commit('showSnackBar', 'Debe Completar todos los datos correctamente')
        return false
      }
      if (!offer.image) {
        this.$store.commit('showSnackBar', 'Debe incluir una imagen')
        return false
      }
      return true

    },
    async createOffer() {
      const offer = {
        title: this.titulo,
        description: this.descripcion,
        discount: this.descuento,
        expires_at: this.fecha,
        service_item_id: this.servicio ? this.servicio.serviceItemId : null,
        image: this.imageFile
      }
      this.loading = true

      const valid = this.validateOffer(offer)
      if (!valid) {
        this.loading = false
        return
      }
      const sended = await this.sendToApi(offer)

      if (sended.ok) {
        this.loading = false
        this.close()
      }
      this.loading = false

    },
    async sendToApi(offer) {
      const sended =  await this.$store.dispatch('offers/addNewOffer', offer)
      this.$emit('addedItem')
      return sended
    },
    clean() {
      this.fecha = this.$moment()
        .add(21, 'days')
        .format('YYYY-MM-DD')
      this.servicio = null
      this.descuento = 0
      this.titulo = ''
      this.descripcion = ''
      this.image = 'http://placehold.it/400x200'
      this.imageFile = null
    },
    close() {
      this.clean()
      this.$emit('close')
    },
    openMobileDate() {
      if (this.$vuetify.breakpoint.mdAndUp) return
      this.dateModal = true
    }
  }
}
</script>
<style scoped>
.discount {
  background-color: red;
  color: white;
  display: inline-block;
  padding: 4px 10px;
  position: absolute;
  top: 20px;
  right: 0;
}
.discount h2 {
  font-weight: 900;
}
</style>
